import { render, staticRenderFns } from "./VueTable.vue?vue&type=template&id=53917f0a&"
import script from "./VueTable.vue?vue&type=script&lang=js&"
export * from "./VueTable.vue?vue&type=script&lang=js&"
import style0 from "./VueTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports